import { makeAutoObservable } from 'mobx';

export class ViewJobServiceStore {
  jobInfo: any = null;
  score = 0;

  constructor() {
    makeAutoObservable(this);
  }

  setJobInfo(info: any) {
    this.jobInfo = info;
  }

  setScore(score: number) {
    this.score = score;
  }

  clearJobInfo() {
    this.jobInfo = null;
    this.score = 0;
  }
}

export const viewJobServiceStore = new ViewJobServiceStore();
